/* eslint-disable
    func-names,
    no-shadow,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = ['Model'];

const factory = function (Model) {
  let Region;
  return (Region = (function () {
    Region = class Region extends Model {
      static initClass() {
        this.prototype.$resource = 'region';
        this.prototype.$idSerializers = ['countryCode', 'regionCode'];

        this.prototype.countryCode = null;
        this.prototype.regionCode = null;
        this.prototype.name = null;
        this.prototype.taxPercent = null;
      }

      $init() {}
    };
    Region.initClass();
    return Region; // disable fetching on instantiation
  })());
};

factory.$inject = deps;

const moduleDeps = [require('data/util').name];

module.exports = angular.module('bench.data.model.region', moduleDeps).factory('Region', factory);
